<template>
  <w-modal
    v-model="show"
    :title="$t(title)"
    :close-button="$t('buttons.cancel')"
    :submit-button="$t('buttons.save')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-12">
        <span class="label">{{ $t('columns.userName') }}:</span>
        {{ firstName }}
        {{ lastName }}
      </div>

      <div class="form-group col-12">
        <span class="label">E-mail:</span>
        {{ email }}
      </div>

      <div class="form-group col-12">
        <div class="mb-2 team-title text-uppercase">{{ $t('tabs.club.teams') }}</div>

        <w-checkbox
          v-for="team in teams"
          :key="team.value"
          class="item"
          :model="$schema.teamIds"
          :value="team.value"
          :title="team.text"
        />
      </div>

      <div class="form-group col-12">
        <span class="label">{{ $t('messages.offer.additionalInformation') }}</span>

        <p class="scroll-text" v-html="content"></p>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/offerAccept.schema';

const emptyData = () => ({ teamIds: [] });

// @vuese
// Modal do akceptacji wniosku
// @group Components
export default {
  mixins: [manageMixin('club/offer', {}, emptyData)],
  schema,
  created() {
    this.$store.dispatch(`team/list`, { count: -1, clubId: this.clubId });
  },
  computed: {
    title() {
      return this.id ? 'modals.offer-edit' : 'modals.offer-add';
    },
    ...mapState({
      teams: state => state.team.list.map(item => ({ value: item.id, text: item.name })),
      stateData: state => state.club.offers.data
    }),
    clubId() {
      return this.$route.params.clubId;
    },
    firstName() {
      return this.stateData ? this.stateData.profile.firstName : '';
    },
    lastName() {
      return this.stateData ? this.stateData.profile.lastName : '';
    },
    email() {
      return this.stateData ? this.stateData.profile.email : '';
    },
    content() {
      return this.stateData ? this.stateData.content : '';
    }
  },
  methods: {
    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setData(emptyData(), undefined, true);
      this.$schema.$reset();
    }
  }
};
</script>

<style>
.team-title {
  font-size: 0.8rem;
  color: #27738d;
}
.item {
  font-size: 0.8125rem;
}
</style>
